import { gql, type TypedDocumentNode } from '@apollo/client';
import {
	type InternalUserModerationInfoQueryQuery,
	type InternalUserModerationInfoQueryQueryVariables,
} from '@apps/www/src/__generated__/graphql';

const InternalUserModerationInfoQuery: TypedDocumentNode<
	InternalUserModerationInfoQueryQuery,
	InternalUserModerationInfoQueryQueryVariables
> = gql`
	query InternalUserModerationInfoQuery($userID: ID!) {
		internalUserModerationInfo(userID: $userID) {
			createdAt
			lastActivityAt
			subscriptions {
				type
				status
				planID
			}
			purchases {
				product
			}
			locationCountryCode
			class
		}
	}
`;

export default InternalUserModerationInfoQuery;
